import { render, staticRenderFns } from "./ISASound.vue?vue&type=template&id=dd512470&"
import script from "./ISASound.vue?vue&type=script&lang=js&"
export * from "./ISASound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports